// src/common/components/leadForm/LeadForm.tsx
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getClientConfig } from "../../../config/runtimeConfig";
import { selectCurrentUser } from "../../../store/slices/currentUserSlice";
import { useLeadForm } from "./useLeadForm";
import { ROUTES } from "../../utils/constants";
import styles from "./LeadForm.module.scss";

export const LeadForm: React.FC = () => {
  const config = getClientConfig();
  const currentUser = useSelector(selectCurrentUser);
  const isAuth = !!currentUser;
  const leadFeature = config.leadFeature;
  const callButton = config.callButton;

  const {
    phone,
    setPhone,
    consent,
    setConsent,
    loading,
    success,
    error,
    phoneError,
    submit,
    isOnline,
    phoneNumber,
  } = useLeadForm();

  if (!leadFeature?.enabled && !callButton) return null;

  const title = leadFeature?.title || "Заказать звонок";
  const description =
    leadFeature?.description || "Оставьте телефон, и мы перезвоним";

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!isAuth && !consent) return;
    submit(phone);
  };

  const isDisabled = loading || phoneError || !phone || (!isAuth && !consent);

  return (
    <section className={styles.leadForm}>
      <div className={styles.container}>
        <div className={styles.contentLeft}>
          <h3 className={styles.title}>{title}</h3>
          <p className={styles.description}>{description}</p>
        </div>

        <div className={styles.contentRight}>
          {success ? (
            <div className={styles.thanksBlock}>
              <h3 className={styles.thanksTitle}>Спасибо!</h3>
              <p className={styles.thanksText}>
                Мы свяжемся с вами в ближайшее время.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className={styles.form}>
              <input
                type="tel"
                placeholder="+7 (999) 123-45-67"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                disabled={loading || !isOnline}
                className={`${styles.input} ${phoneError ? styles.inputError : ""}`}
              />
              {phoneError && (
                <p className={styles.phoneError}>
                  Введите корректный номер телефона
                </p>
              )}

              {!isAuth && (
                <div className={styles.consentRow}>
                  <label className={styles.checkbox}>
                    <input
                      type="checkbox"
                      checked={consent}
                      onChange={(e) => setConsent(e.target.checked)}
                      disabled={loading}
                    />
                    <span className={styles.checkmark} />
                  </label>
                  <div className={styles.consentText}>
                    Я согласен с{" "}
                    <Link
                      to={ROUTES.PRIVACY_POLICY}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      политикой конфиденциальности
                    </Link>
                    ,{" "}
                    <Link
                      to={ROUTES.PERSONAL_DATA_AGREEMENT}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      согласием на обработку данных
                    </Link>{" "}
                    и{" "}
                    <Link
                      to={ROUTES.USER_AGREEMENT}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      пользовательским соглашением
                    </Link>
                  </div>
                </div>
              )}

              {isOnline ? (
                <button
                  type="submit"
                  disabled={isDisabled}
                  className={styles.button}
                >
                  {loading ? "Отправка..." : "Отправить"}
                </button>
              ) : (
                <button
                  type="button"
                  className={styles.button}
                  onClick={() => (window.location.href = `tel:${phoneNumber}`)}
                >
                  Нет сети Позвонить
                </button>
              )}
              {error && (
                <p className={styles.error}>
                  Ошибка отправки. Попробуйте позже.
                </p>
              )}
            </form>
          )}
        </div>
      </div>
    </section>
  );
};
